import React from "react";
import NotFoundRoute from "../Components/NotFound/NotFound";
import { ApplicationRoles } from "./Settings";
import { GetParams } from "../Helpers/HttpHelper";

const EntityLocationComponents = React.lazy(() => import('../Screens/EntityLocation/Index'));
const EntityComponents = React.lazy(() => import('../Screens/Entity/index'));
const PendingApprovalComponents = React.lazy(() => import('../Screens/PendingApproval/index'));
const ContractComponents = React.lazy(() => import('../Screens/Contract/index'));
const TransactionComponents = React.lazy(() => import('../Screens/Transaction/index'));
const BookingTypeComponents = React.lazy(() => import('../Screens/BookingType/index'));
const RecourceCompnents = React.lazy(() => import('../Screens/Resource/Index'));
const DashboardComponent = React.lazy(() => import('../Screens/Dashboard/index'));
const CalendarComponent = React.lazy(() => import('../Screens/Calendar/index'));
const FeatureBannerComponent = React.lazy(() => import('../Screens/FeatureBanner/index'));
const InsuranceCompanyComponent = React.lazy(() => import('../Screens/InsuranceCompany/index'));
const CountryTaxSetupComponent = React.lazy(() => import('../Screens/CountryTaxSetup'));
const ShiftComponent = React.lazy(() => import('../Screens/Shift/index'));
const SubscriptionLevelComponents = React.lazy(() => import('../Screens/SubscriptionLevel/index'));
const SubscriptionLevelBenefitDetailsComponents = React.lazy(() => import('../Screens/SubscriptionLevelBenefitDetails/index'));
const SubscriptionMonthlyPeriodDetailsComponents = React.lazy(() => import('../Screens/SubscriptionMonthlyPeriodDetails/index'));
const TreatmentsComponent = React.lazy(() => import('../Screens/Treatments'));
const KnowledgeBaseComponent = React.lazy(() => import('../Screens/KnowledgeBase'));
const NewsComponent = React.lazy(() => import('../Screens/News'));

export const ApplicationRoutes = () => {

    let entityId = GetParams("EntityId");
    let entityLocationId = GetParams("EntityLocationId");
    let optionId = GetParams("OptionId");
    let contractId = GetParams("ContractId");
    let parentTransactionId = GetParams("ParentTransactionId");
    let bookingTypeId = GetParams("BookingTypeId");
    let requestId = GetParams("RequestId");
    let calendarId = GetParams("CalendarId");
    let bannerId = GetParams("BannerId");
    let insuranceId = GetParams("InsuranceId");
    let workingHoursSetId = GetParams("WorkingHoursSetId");
    let shiftId = GetParams("ShiftId");
    let subscriptionLevelId = GetParams("SubscriptionLevelId");
    let subscriptionBenefitId = GetParams("SubscriptionBenefitId");
    let subscriptionMonthlyPeriodId = GetParams("SubscriptionMonthlyPeriodId");
    let treatmentId = GetParams("TreatmentId");
    let localeId = GetParams("LocaleId");
    let newsId = GetParams("NewsId");
    
    return {
        BaseRoute: {
            name: "Dashboard",
            route: "/",
            roles: [],
            component: <DashboardComponent component="dashboard" />,
            breadcrumbs: [{}],
            requireAccountManager: false
        },
        News: {
            name: "News",
            route: "/news",
            roles: [ApplicationRoles.AdminGroup],
            component: <NewsComponent component="news" />,
            breadcrumbs: [{
                link: "/news",
                title: "News"
            }],
            requireAccountManager: false
        },
        NewNews: {
            name: "NewNews",
            route: "/news/new",
            roles: [ApplicationRoles.AdminGroup],
            component: <NewsComponent component="createNews" />,
            breadcrumbs: [{
                link: "/news",
                title: "News"
            }, {
                link: "/news/new",
                title: "Create News"
            }],
            requireAccountManager: false
        },
        EditNews: {
            name: "EditNews",
            route: "/news/edit",
            roles: [ApplicationRoles.AdminGroup],
            component: <NewsComponent component="editNews" />,
            breadcrumbs: [{
                link: "/news",
                title: "News"
            }, {
                link: `/news/edit?NewsId=${newsId}&LocaleId=${localeId}`,
                title: "Edit News"
            }],
            requireAccountManager: false
        },
        FeatureBanners: {
            name: "FeatureBanners",
            route: "/featureBanner/featureBanners",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <FeatureBannerComponent component="featureBanners" />,
            breadcrumbs: [{
                link: "/featureBanner/featureBanners",
                title: "Feature Banners List"
            }],
            requireAccountManager: false
        },
        NewFeatureBanner: {
            name: "NewFeatureBanner",
            route: "/featureBanner/new-featureBanner",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <FeatureBannerComponent component="createFeatureBanner" />,
            breadcrumbs: [{
                link: "/featureBanner/new-featureBanner",
                title: "Feature Banner List"
            },
            {
                link: "/featureBanner/new-featureBanner",
                title: "Create Feature Banner"
            }
            ],
            requireAccountManager: false
        },
        EditFeatureBanner: {
            name: "editFeatureBanner",
            route: "/featureBanner/edit-featureBanner",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <FeatureBannerComponent component="editFeatureBanner" />,
            breadcrumbs: [{
                link: "/featureBanner/edit-featureBanner",
                title: "Feature Banner List"
            },
            {
                link: `/featureBanner/edit-featureBanner?BannerId=${bannerId}`,
                title: "Edit Feature Banner"
            }
            ],
            requireAccountManager: false
        },
        Shifts: {
            name: "Shifts",
            route: "/shift/shifts",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <ShiftComponent component="shifts" />,
            breadcrumbs: [{
                link: `/shift/shifts?WorkingHourSetId=${workingHoursSetId}`,
                title: "Shifts List"
            }],
            requireAccountManager: false
        },
        NewShift: {
            name: "NewShift",
            route: "/shift/new-shift",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <ShiftComponent component="createShifts" />,
            breadcrumbs: [{
                link: `/shift/shifts?WorkingHourSetId=${workingHoursSetId}`,
                title: "Shift List"
            },
            {
                link: `/shift/new-shift?WorkingHourSetId=${workingHoursSetId}`,
                title: "Create Shift"
            }
            ],
            requireAccountManager: false
        },
        EditShift: {
            name: "editShift",
            route: "/shift/edit-shift",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <ShiftComponent component="editShifts" />,
            breadcrumbs: [{
                link: `/shift/shifts?WorkingHourSetId=${workingHoursSetId}`,
                title: "Shifts List"
            },
            {
                link: `/shift/edit-shift?WorkingHourSetId=${workingHoursSetId}&ShiftId=${shiftId}`,
                title: "Edit Shift"
            }
            ],
            requireAccountManager: false
        },
        InsuranceCompanies: {
            name: "InsuranceCompanies",
            route: "/insuranceCompany/insuranceCompanies",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <InsuranceCompanyComponent component="insuranceCompanies" />,
            breadcrumbs: [{
                link: "/insuranceCompany/insuranceCompanies",
                title: "Insurance Companies List"
            }],
            requireAccountManager: false
        },
        CountryTaxSetups: {
            name: "CountryTaxSetups",
            route: "/countryTaxSetup/country-tax-setups",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <CountryTaxSetupComponent />,
            breadcrumbs: [{
                link: "/countryTaxSetup/country-tax-setups",
                title: "Country Tax Setup"
            }],
            requireAccountManager: false
        },
        NewInsuranceCompany: {
            name: "NewInsuranceCompany",
            route: "/insuranceCompany/new-insuranceCompany",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <InsuranceCompanyComponent component="createInsuranceCompany" />,
            breadcrumbs: [{
                link: "/insuranceCompany/insuranceCompanies",
                title: "Insurance Companies List"
            },
            {
                link: "/insuranceCompany/new-insuranceCompany",
                title: "Create Insurance Company"
            }
            ],
            requireAccountManager: false
        },
        EditInsuranceCompany: {
            name: "editInsuranceCompany",
            route: "/insuranceCompany/editInsuranceCompany",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <InsuranceCompanyComponent component="editInsuranceCompany" />,
            breadcrumbs: [{
                link: "/insuranceCompany/insuranceCompanies",
                title: "Insurance Company List"
            },
            {
                link: `/insuranceCompany/edit-InsuranceCompany?InsuranceId=${insuranceId}`,
                title: "Edit Insurance Company"
            }
            ],
            requireAccountManager: false
        },
        Calendars: {
            name: "Calendars",
            route: "/calendar/calendars",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <CalendarComponent component="calendars" />,
            breadcrumbs: [{
                link: "/calendar/calendars",
                title: "Calendars List"
            }],
            requireAccountManager: false
        },

        NewCalendar: {
            name: "NewCalendar",
            route: "/calendar/new-calendar",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <CalendarComponent component="createCalendar" />,
            breadcrumbs: [{
                link: "/calendar/calendars",
                title: "Calendars List"
            },
            {
                link: "/calendar/new-calendar",
                title: "Create Calendar"
            }
            ],
            requireAccountManager: false
        },
        EditCalendar: {
            name: "EditCalendar",
            route: "/calendar/edit-calendar",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <CalendarComponent component="editCalendar" />,
            breadcrumbs: [{
                link: "/calendar/calendars",
                title: "Calendars List"
            },
            {
                link: `/calendar/edit-calendar?CalendarId=${calendarId}`,
                title: "Edit Calendar"
            }
            ],
            requireAccountManager: false
        },
        CreateEntityLocation: {
            title: "Create Entity Location",
            name: "EntityLocation",
            route: "/entityLocation/new-entity-location",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <EntityLocationComponents component="createEntityLocation" />,
            breadcrumbs: [{
                link: "/entity/entities",
                title: "Entities List"
            },
            {
                link: `/entity/edit-entity?EntityId=${entityId}`,
                title: "View Entity"
            },
            {
                link: `/entityLocation/entity-locations?EntityId=${entityId}`,
                title: "Entity Locations List"
            },
            {
                link: `/entityLocation/new-entity-location?EntityId=${entityId}`,
                title: "Create Entity Location"
            }
            ],
            requireAccountManager: true
        },
        EditEntityLocation: {
            name: "EntityLocation",
            route: "/entityLocation/edit-entity-location",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <EntityLocationComponents component="editEntityLocation" />,
            breadcrumbs: [{
                link: "/entity/entities",
                title: "Entities List"
            },
            {
                link: `/entity/edit-entity?EntityId=${entityId}`,
                title: "Edit Entity"
            },
            {
                link: `/entityLocation/entity-locations?EntityId=${entityId}`,
                title: "Entity Locations List"
            },
            {
                link: `/entityLocation/edit-entity-location?EntityId=${entityId}&EntityLocationId=${entityLocationId}`,
                title: "Edit Entity Location"
            }
            ],
            requireAccountManager: true
        },
        EntityLocation: {
            title: "Entity Locations",
            name: "EntityLocation",
            route: "/entityLocation/entity-locations",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <EntityLocationComponents component="entityLocations" />,
            breadcrumbs: [{
                link: "/entity/entities",
                title: "Entities List"
            },
            {
                link: `/entity/edit-entity?EntityId=${entityId}`,
                title: "Edit Entity"
            },
            {
                link: `/entityLocation/entity-locations?EntityId=${entityId}`,
                title: "Entity Locations List"
            }
            ],
            requireAccountManager: false
        },
        Options: {
            name: "Options",
            route: "/Options/service_Options",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <RecourceCompnents component="Options" />,
            breadcrumbs: [{
                link: "/entity/entities",
                title: "Entities List"
            },
            {
                link: `/entity/edit-entity?EntityId=${entityId}`,
                title: "Edit Entity"
            },
            {
                link: `/entityLocation/entity-locations?EntityId=${entityId}`,
                title: "Entity Locations List"
            },
            {
                link: `/entityLocation/edit-entity-location?EntityId=${entityId}&EntityLocationId=${entityLocationId}`,
                title: "Edit Entity Location"
            },
            {
                link: `/Options/service_Options?EntityId=${entityId}&EntityLocationId=${entityLocationId}`,
                title: "Resources List"
            }
            ],
            requireAccountManager: false
        },
        CreateOptions: {
            name: "NewOption",
            route: "/Options/create_Options",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <RecourceCompnents component="createOptions" />,
            breadcrumbs: [{
                link: "/entity/entities",
                title: "Entities List"
            },
            {
                link: `/entity/edit-entity?EntityId=${entityId}`,
                title: "Edit Entity"
            },
            {
                link: `/entityLocation/entity-locations?EntityId=${entityId}`,
                title: "Entity Locations List"
            },
            {
                link: `/entityLocation/edit-entity-location?EntityId=${entityId}&EntityLocationId=${entityLocationId}`,
                title: "Edit Entity Location"
            },
            {
                link: `/Options/service_Options?EntityId=${entityId}&EntityLocationId=${entityLocationId}`,
                title: "Resources List"
            },
            {
                link: `/Options/create_Options?EntityId=${entityId}&EntityLocationId=${entityLocationId}`,
                title: "Create Resource"
            }
            ],
            requireAccountManager: false
        },
        EditOptions: {
            name: "EditOptions",
            route: "/Options/edit_Options",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <RecourceCompnents component="editOptions" />,
            breadcrumbs: [{
                link: "/entity/entities",
                title: "Entities List"
            },
            {
                link: `/entity/edit-entity?EntityId=${entityId}`,
                title: "Edit Entity"
            },
            {
                link: `/entityLocation/entity-locations?EntityId=${entityId}`,
                title: "Entity Locations List"
            },
            {
                link: `/entityLocation/edit-entity-location?EntityId=${entityId}&EntityLocationId=${entityLocationId}`,
                title: "Edit Entity Location"
            },
            {
                link: `/Options/service_Options?EntityId=${entityId}&EntityLocationId=${entityLocationId}`,
                title: "Resources List"
            },
            {
                link: `/Options/edit_Options?EntityId=${entityId}&OptionId=${optionId}&EntityLocationId=${entityLocationId}`,
                title: "Edit Resource"
            }
            ],
            requireAccountManager: false
        },
        Entities: {
            name: "Entities",
            route: "/entity/entities",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <EntityComponents component="entities" />,
            breadcrumbs: [{
                link: "/entity/entities",
                title: "Entity List"
            }],
            requireAccountManager: false
        },
        IncompleteEntities: {
            name: "IncompleteEntities",
            route: "/entity/incompleteEntities",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <EntityComponents component="incompleteEntities" />,
            breadcrumbs: [{
                link: "/entity/incompleteEntities",
                title: "Incomplete Entities"
            }],
            requireAccountManager: false
        },
        PendingApprovalServices: {
            name: "PendingApprovalServices",
            route: "/pendingApprovalServices",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <PendingApprovalComponents component="pendingApprovalServices" />,
            breadcrumbs: [{
                link: "/pendingApprovalServices",
                title: "Pending Approval Services"
            }],
            requireAccountManager: false
        },
        EditPendingApprovalService: {
            name: "EditPendingApprovalService",
            route: "/editPendingApprovalService",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <PendingApprovalComponents component="editPendingApprovalService" />,
            breadcrumbs: [{
                link: "/pendingApprovalServices",
                title: "Pending Approval Services"
            },
            {
                link: `/editPendingApprovalService?RequestId=${requestId}`,
                title: "Edit Pending Approval Service"
            }],
            requireAccountManager: false
        },
        NewEntity: {
            name: "NewEntity",
            route: "/entity/new-entity",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <EntityComponents component="createEntity" />,
            breadcrumbs: [{
                link: "/entity/entities",
                title: "Entities List"
            },
            {
                link: "/entity/new-entity",
                title: "Create Entity"
            }
            ],
            requireAccountManager: false
        },
        EditEntity: {
            name: "EditEntity",
            route: "/entity/edit-entity",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <EntityComponents component="editEntity" />,
            breadcrumbs: [{
                link: "/entity/entities",
                title: "Entities List"
            },
            {
                link: `/entity/edit-entity?EntityId=${entityId}`,
                title: "Edit Entity"
            }
            ],
            requireAccountManager: false
        },
        Contracts: {
            name: "Contracts",
            route: "/contract/contracts",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <ContractComponents component="contracts" />,
            breadcrumbs: [
                {
                    link: `/contract/contracts`,
                    title: "Contracts"
                }
            ],
            requireAccountManager: false
        },
        NewContract: {
            name: "NewContract",
            route: "/contract/new-contract",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <ContractComponents component="createContract" />,
            breadcrumbs: [
                {
                    link: `/contract/contracts`,
                    title: "Contracts"
                },
                {
                    link: `/contract/new-contract`,
                    title: "New Contract"
                }
            ],
            requireAccountManager: false
        },
        EditContract: {
            name: "EditContract",
            route: "/contract/edit-contract",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <ContractComponents component="editContract" />,
            breadcrumbs: [
                {
                    link: `/contract/contracts`,
                    title: "Contracts"
                },
                {
                    link: `/contract/edit-contract?ContractId=${contractId}`,
                    title: "Edit Contract"
                }
            ],
            requireAccountManager: false
        },
        RenewContract: {
            name: "RenewContract",
            route: "/contract/renew-contract",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <ContractComponents component="renewContract" />,
            breadcrumbs: [
                {
                    link: `/contract/contracts`,
                    title: "Contracts"
                },
                {
                    link: `/contract/renew-contract?ContractId=${contractId}`,
                    title: "Renew Contract"
                }
            ],
            requireAccountManager: false
        },
        ContractTransactions: {
            name: "ContractTransactions",
            route: "/contract/transactions",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <TransactionComponents component="transactions" />,
            breadcrumbs: [
                {
                    link: `/contract/contracts`,
                    title: "Contracts"
                },
                {
                    link: `/contract/edit-contract?ContractId=${contractId}`,
                    title: "Edit Contract"
                },
                {
                    link: `/contract/transactions?ContractId=${contractId}`,
                    title: "Transactions"
                }
            ],
            requireAccountManager: false
        },
        NewTransaction: {
            name: "NewTransaction",
            route: "/contract/transactions/new-transaction",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <TransactionComponents component="createTransaction" />,
            breadcrumbs: [
                {
                    link: `/contract/contracts`,
                    title: "Contracts"
                },
                {
                    link: `/contract/edit-contract?ContractId=${contractId}`,
                    title: "Edit Contract"
                },
                {
                    link: `/contract/transactions?ContractId=${contractId}`,
                    title: "Transactions"
                },
                {
                    link: `/contract/transactions/new-transaction?ContractId=${contractId}`,
                    title: "Create Transaction"
                }
            ],
            requireAccountManager: false
        },
        RefundTransaction: {
            name: "RefundTransaction",
            route: "/contract/transactions/refund-transaction",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <TransactionComponents component="refundTransaction" />,
            breadcrumbs: [
                {
                    link: `/contract/contracts`,
                    title: "Contracts"
                },
                {
                    link: `/contract/edit-contract?ContractId=${contractId}`,
                    title: "Edit Contract"
                },
                {
                    link: `/contract/transactions?ContractId=${contractId}`,
                    title: "Transactions"
                },
                {
                    link: `/contract/transactions/refund-transaction?ContractId=${contractId}&ParentTransactionId=${parentTransactionId}`,
                    title: "Refund Transaction"
                }
            ],
            requireAccountManager: false
        },
        Transactions: {
            name: "Transactions",
            route: "/transactions",
            roles: [ApplicationRoles.FinanceGroup],
            component: <TransactionComponents component="transactions" />,
            breadcrumbs: [{}],
            requireAccountManager: false
        },
        BookingType: {
            name: "BookingType",
            route: "/Bookingtype",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <BookingTypeComponents component="bookingTypes" />,
            breadcrumbs: [{
                link: "/Bookingtype",
                title: "Booking Types"
            }],
            requireAccountManager: false
        },
        NewBookingType: {
            name: "NewBookingType",
            route: "/bookingType/bookingtypes/new-bookingtype",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <BookingTypeComponents component="createBookingType" />,
            breadcrumbs: [{
                link: "/Bookingtype",
                title: "Booking Types"
            },
            {
                link: "/bookingType/bookingtypes/new-bookingtype",
                title: "Create Booking Type"
            }],
            requireAccountManager: false
        },
        EditBookingType: {
            name: "EditBookingType",
            route: "/bookingType/bookingtypes/edit-bookingtype",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <BookingTypeComponents component="editBookingType" />,
            breadcrumbs: [{
                link: "/Bookingtype",
                title: "Booking Types"
            },
            {
                link: `/bookingType/bookingtypes/edit-bookingtype?BookingTypeId=${bookingTypeId}`,
                title: "Edit Booking Type"
            }],
            requireAccountManager: false
        },
        SubscriptionLevels: {
            name: "SubscriptionLevels",
            route: "/subscriptionLevel/subscriptionLevels",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <SubscriptionLevelComponents component="subscriptionlevels" />,
            breadcrumbs: [
                {
                    link: `/subscriptionLevel/subscriptionLevels`,
                    title: "SubscriptionLevels"
                }
            ],
            requireAccountManager: false
        },
        NewSubscriptionLevel: {
            name: "NewSubscriptionLevel",
            route: "/subscriptionLevel/new-subscriptionLevel",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <SubscriptionLevelComponents component="createSubscriptionLevel" />,
            breadcrumbs: [
                {
                    link: `/subscriptionLevel/subscriptionLevels`,
                    title: "Subscription Levels"
                },
                {
                    link: `/subscriptionLevel/new-subscriptionLevel`,
                    title: "New SubscriptionLevel"
                }
            ],
            requireAccountManager: false
        },
        EditSubscriptionLevel: {
            name: "SubscriptionLevels",
            route: "/subscriptionLevel/edit-subscriptionLevel",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <SubscriptionLevelComponents component="editSubscriptionLevel" />,
            breadcrumbs: [
                {
                    link: `/subscriptionLevel/subscriptionLevels`,
                    title: "Subscription Levels"
                },
                {
                    link: `/subscriptionLevel/edit-subscriptionLevel=${subscriptionLevelId}`,
                    title: "Edit Subscription Level"
                }
            ],
            requireAccountManager: false
        },
        SubscriptionLevelBenefitDetails: {
            name: "SubscriptionLevelBenefitDetails",
            route: "/subscriptionLevelBenefitDetails/subscriptionLevelBenefitDetails",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <SubscriptionLevelBenefitDetailsComponents component="subscriptionLevelBenefitDetails" />,
            breadcrumbs: [
                {
                    link: `/subscriptionLevelBenefitDetail/subscriptionLevelBenefitDetails?SubscriptionLevelId=${subscriptionLevelId}`,
                    title: "SubscriptionLevelBenefitDetails"
                }
            ],
            requireAccountManager: false
        },
        NewSubscriptionLevelBenefitDetails: {
            name: "NewSubscriptionLevelBenefitDetails",
            route: "/subscriptionLevel/new-subscriptionLevelBenefitDetails",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <SubscriptionLevelBenefitDetailsComponents component="createSubscriptionLevelBenefitDetails" />,
            breadcrumbs: [
                {
                    link: `/subscriptionLevelBenefitDetail/subscriptionLevelBenefitDetails?SubscriptionLevelId=${subscriptionLevelId}`,
                    title: "Subscription Level Benefi tDetails"
                },
                {
                    link: `/subscriptionLevelBenefitDetail/new-subscriptionLevelBenefitDetail?SubscriptionLevelId=${subscriptionLevelId}`,
                    title: "New subscription Level Benefit Detail"
                }
            ],
            requireAccountManager: false
        },
        EditSubscriptionLevelBenefitDetails: {
            name: "EditSubscriptionLevelBenefitDetails",
            route: "/subscriptionLevelBenefitDetails/edit-subscriptionLevelBenefitDetails",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <SubscriptionLevelBenefitDetailsComponents component="editSubscriptionLevelBenefitDetails" />,
            breadcrumbs: [
                {
                    link: `/subscriptionLevelBenefitDetail/subscriptionLevelBenefitDetails?SubscriptionLevelId=${subscriptionLevelId}`,
                    title: "Subscription Level Benefi tDetails"
                },
                {
                    link: `/subscriptionLevelBenefitDetail/edit-subscriptionLevelBenefitDetail?SubscriptionBenefitId=${subscriptionBenefitId}&SubscriptionLevelId=${subscriptionLevelId}`,
                    title: "Edit Subscription Level"
                }
            ],
            requireAccountManager: false
        },
        SubscriptionMonthlyPeriodDetails: {
            name: "SubscriptionMonthlyPeriodDetails",
            route: "/subscriptionMonthlyPeriodDetails/subscriptionMonthlyPeriodDetails",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <SubscriptionMonthlyPeriodDetailsComponents component="subscriptionMonthlyPeriodDetails" />,
            breadcrumbs: [
                {
                    link: `/subscriptionMonthlyPeriodDetails/subscriptionMonthlyPeriodDetailss`,
                    title: "SubscriptionMonthlyPeriodDetails"
                }
            ],
            requireAccountManager: false
        },
        NewSubscriptionMonthlyPeriodDetails: {
            name: "NewSubscriptionMonthlyPeriodDetails",
            route: "/subscriptionMonthlyPeriodDetails/new-subscriptionMonthlyPeriodDetails",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <SubscriptionMonthlyPeriodDetailsComponents component="createSubscriptionMonthlyPeriodDetail" />,
            breadcrumbs: [
                {
                    link: `/subscriptionMonthlyPeriodDetails/subscriptionMonthlyPeriodDetails`,
                    title: "Subscription Monthly Period Details"
                },
                {
                    link: `/subscriptionLevelBenefitDetail/new-subscriptionMonthlyPeriodDetails`,
                    title: "New Subscription Monthly Period Details"
                }
            ],
            requireAccountManager: false
        },
        EditSubscriptionMonthlyPeriodDetails: {
            name: "EditSubscriptionMonthlyPeriodDetails",
            route: "/subscriptionMonthlyPeriodDetails/edit-subscriptionMonthlyPeriodDetails",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <SubscriptionMonthlyPeriodDetailsComponents component="editSubscriptionMonthlyPeriodDetails" />,
            breadcrumbs: [
                {
                    link: `/subscriptionMonthlyPeriodDetails/subscriptionMonthlyPeriodDetails`,
                    title: "subscription Monthly Period Details"
                },
                {
                    link: `/subscriptionMonthlyPeriodDetails/edit-subscriptionMonthlyPeriodDetails?SubscriptionMonthlyPeriodId=${subscriptionMonthlyPeriodId}&LocaleId=${localeId}`,
                    title: "Edit subscription Monthly Period Details"
                }
            ],
            requireAccountManager: false
        },
        TreatmentsUnitOfMeasure: {
            name: "TreatmentsUnitOfMeasure",
            route: "/treatments/unit-of-measures",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <TreatmentsComponent component="unitOfMeasure" />,
            breadcrumbs: [
                {
                    link: "/treatments/unit-of-measures",
                    title: "Units of measure"
                }
            ],
            requireAccountManager: false
        },
        TreatmentBodyImages: {
            name: "TreatmentBodyImages",
            route: "/treatments/bodyImages",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <TreatmentsComponent component="bodyImage" />,
            breadcrumbs: [
                {
                    link: "/treatments/shapes",
                    title: "Body images"
                }
            ],
            requireAccountManager: false
        },
        Treatments: {
            name: "Treatments",
            route: "/treatments/treatments",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <TreatmentsComponent component="treatments" />,
            breadcrumbs: [
                {
                    link: "/treatments/treatments",
                    title: "Treatments"
                }
            ],
            requireAccountManager: false
        },
        CreateTreatment: {
            name: "CreateTreatment",
            route: "/treatments/new-treatment",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <TreatmentsComponent component="createTreatment" />,
            breadcrumbs: [
                {
                    link: "/treatments/treatments",
                    title: "Treatments"
                },
                {
                    link: "/treatments/new-treatment",
                    title: "Create treatment"
                }
            ],
            requireAccountManager: false
        },
        EditTreatment: {
            name: "EditTreatment",
            route: "/treatments/edit-treatment",
            roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup],
            component: <TreatmentsComponent component="editTreatment" />,
            breadcrumbs: [
                {
                    link: "/treatments/treatments",
                    title: "Treatments"
                },
                {
                    link: `/treatments/edit-treatment?TreatmentId=${treatmentId}`,
                    title: "Treatment details"
                }
            ],
            requireAccountManager: false
        },
        KnowledgeBaseDashboard: { name: "KnowledgeBaseDashboard", route: "/knowledge-base", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="dashboard" />, breadcrumbs: [{ link: "/knowledge-base", title: "Knowledge Base" }], requireAccountManager: false },
        KnowledgeBaseArticles: { name: "KnowledgeBaseArticles", route: "/knowledge-base/articles", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="articles" />, breadcrumbs: [{ link: "/knowledge-base/articles", title: "Knowledge Base Articles" }], requireAccountManager: false },
        KnowledgeBaseArticleNew: { name: "KnowledgeBaseArticleNew", route: "/knowledge-base/articles/new", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="editor" />, breadcrumbs: [{ link: "/knowledge-base/articles/new", title: "Create Knowledge Article" }], requireAccountManager: false },
        KnowledgeBaseArticleEdit: { name: "KnowledgeBaseArticleEdit", route: "/knowledge-base/articles/edit", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="editor" />, breadcrumbs: [{ link: "/knowledge-base/articles/edit", title: "Edit Knowledge Article" }], requireAccountManager: false },
        KnowledgeBaseCategories: { name: "KnowledgeBaseCategories", route: "/knowledge-base/categories", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="categories" />, breadcrumbs: [{ link: "/knowledge-base/categories", title: "Knowledge Categories" }], requireAccountManager: false },
        KnowledgeBaseFaqs: { name: "KnowledgeBaseFaqs", route: "/knowledge-base/faqs", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="faqs" />, breadcrumbs: [{ link: "/knowledge-base/faqs", title: "FAQ Library" }], requireAccountManager: false },
        KnowledgeBaseAnalytics: { name: "KnowledgeBaseAnalytics", route: "/knowledge-base/analytics", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="analytics" />, breadcrumbs: [{ link: "/knowledge-base/analytics", title: "Knowledge Analytics" }], requireAccountManager: false },
        KnowledgeBaseAiOptimization: { name: "KnowledgeBaseAiOptimization", route: "/knowledge-base/ai-optimization", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="aiOptimization" />, breadcrumbs: [{ link: "/knowledge-base/ai-optimization", title: "AI Optimization" }], requireAccountManager: false },
        KnowledgeBaseTranslations: { name: "KnowledgeBaseTranslations", route: "/knowledge-base/translations", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="translations" />, breadcrumbs: [{ link: "/knowledge-base/translations", title: "Translation Center" }], requireAccountManager: false },
        KnowledgeBaseSearch: { name: "KnowledgeBaseSearch", route: "/knowledge-base/search", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="search" />, breadcrumbs: [{ link: "/knowledge-base/search", title: "Knowledge Search" }], requireAccountManager: false },
        KnowledgeBaseSettings: { name: "KnowledgeBaseSettings", route: "/knowledge-base/settings", roles: [ApplicationRoles.AddGroup, ApplicationRoles.EditGroup, ApplicationRoles.AdminGroup], component: <KnowledgeBaseComponent component="settings" />, breadcrumbs: [{ link: "/knowledge-base/settings", title: "Knowledge Settings" }], requireAccountManager: false },
        NotFound: {
            name: "NotFound",
            route: "/404",
            roles: [],
            component: <NotFoundRoute />,
            breadcrumbs: [{}],
            requireAccountManager: false
        }
    }
}
